import React from 'react'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { AnswerOptionStyles } from '../PreviewStyle'

const AnswerOption = ({ answer }) => {
    const { text, is_correct } = answer

    return (
        <AnswerOptionStyles correct={is_correct}>
            {is_correct && <CheckCircleOutlineIcon className="answer-icon correct" fontSize="small" />}
            <span className="answer-text">{text}</span>
        </AnswerOptionStyles>
    )
}

export default AnswerOption
